<script>

  import {Lottie} from 'lottie-svelte'
  /* import bullet from '../public/timecontrol_bullet_highlight.json' */ /* import blitz from '../public/timecontrol_blitz_highlight.json' */

  import "carbon-components-svelte/css/g90.css"
  import {Tooltip} from 'carbon-components-svelte'
  /* import rapid from '../public/timecontrol_rapid_highlight.json' */
  import {sessionData} from '../stores'
  import {PLAYER_STATE} from "../chess-console-app/ChessConsoleAppState.js"
  import Stake from '../components/Stake.svelte'
  import Looking from '../components/Looking.svelte'
  import LocalStorage from '../localstorage'
  import StakeModal from '../components/StakeModal.svelte'
  import SumsubContinue from '../components/SumsubContinue.svelte';
  import Puzzle from '../components/Puzzle.svelte'
  import Game from './Game.svelte'
  import {_} from 'svelte-i18n'
  import {updateBalance, notify} from '../userdata'
  import { toast} from '@zerodevx/svelte-toast/dist'
  import {replace, querystring, location} from 'svelte-spa-router'
  import {onMount} from 'svelte'
  import PlayButton from '../components/PlayButton.svelte'
  import {getAuth, onAuthStateChanged} from 'firebase/auth'
  import {fade, fly} from 'svelte/transition'
  import {createAppAndSendGameRequest} from "../chess-console-app/ChessConsoleApp.js"

  let selected = true
  let expl = false
  export let params = {}
  let paymentTrigger = false
  let sumtoken = ''
  let currentStake
  let queryp

  let trigger = false
  let winToggle = false
  let ln = new LocalStorage('notification_')
  let lo = new LocalStorage('outcome_')
  let lp = new LocalStorage('payment_')
  let linkUsr = null
  let showModal = false
  let tok = undefined




  $: {
    if (params.tc) {
      answerRequest()
    }
  }

  /* $: if ($querystring) { */
  /* queryp = new URLSearchParams($querystring); */
  /* } */

  function hasQueryParam(queryString, paramName) {
    const regex = new RegExp('[\\?&]' + paramName + '=([^&#]*)', 'i');
    const results = regex.exec(queryString);
    return results !== null;
  }



  function getQueryParam(queryString, paramName) {
    const regex = new RegExp('[\\?&]' + paramName + '=([^&#]*)', 'i');
    const results = regex.exec(queryString);
    return results ? decodeURIComponent(results[1]) : null;
  }


  function answerRequest() {
    toast.pop(0)
    /* $sessionData.cardLocked = true */
    createAppAndSendGameRequest($sessionData.user.uid, $sessionData.user.accessToken, params.tc, Number(params.stake), Number(params.code))
  }

  onMount(() => {
    setTimeout(() => {
      trigger = true
    }, 500)

    if(params.tc){

      //$sessionData.playerState = PLAYER_STATE.linkGame
      window.onbeforeunload = function () {
        if($sessionData.playerState !== PLAYER_STATE.idle) {
          return "You are currently playing a game. Are you sure you want to leave?"
        }
      }




      setInterval(() => {
        updateBalance();
      }, 5000)
      answerRequest()

    } else {
      //$sessionData.playerState = PLAYER_STATE.linkGame
      window.onbeforeunload = function () {
        if($sessionData.playerState !== PLAYER_STATE.idle) {
          return "You are currently playing a game. Are you sure you want to leave?"
        }
      }




      setInterval(() => {
        updateBalance();
      }, 5000)





      let notifier = new WebSocket(process.env.GAMBIT_NOTIFY)

      notifier.onopen = function (e) {
        const auth = getAuth();

        onAuthStateChanged(auth, (user) => {
          if (user) {
            // User is signed in, you can send the UID
            notifier.send(JSON.stringify({ _frtok: user.accessToken }));
            tok = user.accessToken
          }
        });
      };

      notifier.onmessage = function(event) {
        const {_frusername, _frtc, _frstake, _frcode} = JSON.parse(event.data)
        toast.push(`<div class="flex gap-x-4 p-4 items-center font-autoscape flex-row"><img class="w-12 h-8" src="fencing.png">

 <div class="flex flex-col gap-y-2">
 <a class="font-autoscape text-gmint text-2xl" href="/#/Play/lnk/usr/${_frtc}/${_frstake}/${_frcode}"> ${_frusername}</a>
 <a class="font-autoscape leading-5 text-white" href="/#/Play/lnk/usr/${_frtc}/${_frstake}/${_frcode}"> challenges you to a ${_frtc} game worth $${_frstake}</a>
 </div>
 </div>`,{
   /* onpop: () => {window.dispatchEvent(new CustomEvent('link_game', {detail: {tc: _frtc, stake: _frstake, code: _frcode}}))}, */
   onpop: () => {
     /* window.dispatchEvent(new CustomEvent('link_game', {detail: {tc: _frtc, stake: _frstake, code: _frcode}})) */
   },
   duration: 15000
 })

      };






      if (hasQueryParam($querystring, "payment_success")) {
        if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1){ replace('/mobile/success')}
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1){ replace('/mobile/success')}
        $sessionData.recent_payment = true
      }
      if (hasQueryParam($querystring,"payment_fail")) {
        if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1){ replace('/mobile/failed')}
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1){ replace('/mobile/failed')}
        $sessionData.payment_failed = true
      }
      if(hasQueryParam($querystring, "user")){
        linkUsr = getQueryParam($querystring, "user")
      }

      window.onbeforeunload = function () {
        if($sessionData.playerState !== PLAYER_STATE.idle) {
          return "You are currently playing a game. Are you sure you want to leave?"
        }
      }
    }


  })

  const switchSelectedCard = (cardName) => {
    if (!$sessionData.cardLocked) {
      if ($sessionData.selectedCard === cardName) {
        $sessionData.selectedCard = ''
      } else {
        $sessionData.selectedCard = cardName
      }
    }
  }


  $: all_levels = $sessionData.guser?.stakes?.options?.every((option) => option.enabled)
  $: currentRating = getStake($sessionData.selectedCard, currentStake) || null
  /* $: isLink = queryp.has('link') */
  $: stakeEnabled = available(currentStake)
  $: hasLink = params.target_link
  $: isResponse = params.target_link == "lnk" && params.target_username == "usr"
  $: linkUserName = params.target_username
  /* $: hasLink = hasQueryParam($querystring, 'user') */
  /* $: linkUID = hasQueryParam($querystring, 'link') */
  $: {
    if ($sessionData.resultForPlayer === "victory" && !winToggle) {
      $sessionData.recent_victory = true
      winToggle = true
      updateBalance()
      setTimeout(() => {
        $sessionData.recent_victory = false
        winToggle = false
      },5000)

    }
  }

  let allowed = false
  $: {
    let kyc_completed = $sessionData.guser.kyc_status == 'completed'
    let sumsub_review_green = $sessionData.sumsubApplication?.reviewResult?.reviewAnswer == 'GREEN'
    let has_funds = $sessionData.guser.current_balance >= currentStake
    let is_god = $sessionData.guser.god
    allowed = (kyc_completed || sumsub_review_green) && has_funds || is_god
  }

  $: {
    if ($querystring == "payment_success") {
      $sessionData.recent_payment = true
      setTimeout(() => {
        $sessionData.recent_payment = false
      }, 5000)

    }
  }

  $: {
    if ($querystring == "payment_fail") {
      $sessionData.payment_failed = true
      setTimeout(() => {
        $sessionData.payment_failed = false
      }, 5000)

    }
  }

  /* $: remainingGames = $sessionData.guser.remaining_games || null */
  function sendLobbyGameRequest() {
    if (hasLink) {
      $sessionData.cardLocked = true
      const code = 0-(Math.floor(Math.random() * 1000000))
      notify(code, params.target_link, $sessionData.selectedCard, Number(currentStake))

      createAppAndSendGameRequest($sessionData.user.uid, $sessionData.user.accessToken, $sessionData.selectedCard, Number(currentStake), code)
    } else {
      $sessionData.cardLocked = true
      createAppAndSendGameRequest($sessionData.user.uid, $sessionData.user.accessToken, $sessionData.selectedCard, Number(currentStake), 1)
    }

  }


     function startPuzzleMode() {

       if ($sessionData.geoCountry == "DE") {
         toast.push($_('puzzle.unavailableInYourRegion'))
         return
       }

       if($sessionData.puzzleCredits < 1) {
         toast.push($_('puzzle.outOfCredits'))
         return
       }

       $sessionData.cardLocked = true
       $sessionData.playerState = PLAYER_STATE.puzzle

     }

  function getStake(tc, stake_) {
    const stake = Number(stake_)
    const gt = $sessionData.guser?.game_types?.find((g) => g.name === tc)
    if (!gt) {
      return null
    }
    const r = gt.stake_rating?.find((g) => g.stake === stake)
    if (!r) {
      return null
    }
    return r.rating
  }

  function toggleStakeModal() {
    $sessionData.stakeModal = !$sessionData.stakeModal
  }

  function available(t_) {
    const t = Number(t_)
    const res = $sessionData.guser?.stakes?.options?.find((g) => g.amount === t)
    return res?.enabled
  }

  </script>

{#if $sessionData.sumsubContinue && !$location.startsWith("/wallet")}
  <div class="continue-sumsub" transition:fly={{y:-20}}>
    <SumsubContinue/>
  </div>
{/if}

{#if $sessionData.guser?.game_types?.length > 0 && trigger && ($location !== "/wallet")}
    <div transition:fly={{y:-20}}  class="select-none bg-space overflow-hidden hidescroll">

      <StakeModal {toggleStakeModal} trigger={showModal} text="hcwi"/>

        <div class:hide={$sessionData.playerState !== PLAYER_STATE.idle && $sessionData.playerState !== PLAYER_STATE.lobbyGameRequestSent}>
        {#if $sessionData.playerState !== PLAYER_STATE.playing && $sessionData.playerState !== PLAYER_STATE.puzzle && $location !== "/puzzle"}
        <div class="select-none bg-space overflow-hidden">
          {#if $querystring == "payment_success"}
            <div class="w-screen fixed">
              <Lottie loop={false} path="particles.json" speed={0.4}/>
            </div>
          {/if}


<div class="play-grid">




  {#key hasLink}
  {#if hasLink && !isResponse}
    <div class="flex p-8 gap-x-4 items-center flex-row link-place ">
      <div class="w-4 h-4 rounded-full bg-gmint animate-pulse"/>
      <p class="font-autoscape"> room: {linkUserName}</p>

    </div>
  {/if}
  {/key}
    <div class="container-card font-brown">


      <div on:click="{() => switchSelectedCard('bullet')}"
           class="{$sessionData.selectedCard === 'bullet' ? 'card-selected flex flex-col p-8' : 'card flex flex-col p-8'}">
        <div class="title gap-x-3 flex flex-row">
          <h3>bullet</h3>
          <h4 class="font-autoscape text-sm">1+0</h4>
        </div>

        {#if currentRating && $sessionData.selectedCard === 'bullet'}
          <div transition:fade class="title-rating flex flex-col">
            <h3 class="text-xl font-brown">rating</h3>
            <h3>{currentRating}</h3>
          </div>
        {/if}
        <div class="mx-auto translate-y-28 h-48 w-48">
          <Lottie path="timecontrol_bullet_highlight.json" speed={0.4}/>
        </div>
        {#if $sessionData.playerState !== PLAYER_STATE.lobbyGameRequestSent}
          <PlayButton {allowed} handleClick={sendLobbyGameRequest}
                      selected={$sessionData.selectedCard === 'bullet'}/>
                    {:else if $sessionData.selectedCard === 'bullet'}
                      <Looking/>
                    {/if}
                    <p class="{$sessionData.selectedCard === 'bullet' ? 'active-slide text-white mt-8 w-full' : 'inactive-slide text-gray-500 mt-8'}">

                      {$_('gameplay.gameTypes.bullet.description')}
                    </p>
      </div>

      <div on:click="{() => switchSelectedCard('blitz')}"
           class="{$sessionData.selectedCard === 'blitz' ? 'p-8 card-selected flex flex-col' : 'card flex flex-col p-8'}">

        <div class="title gap-x-3 flex flex-row">
          <h3>blitz</h3>
          <h4 class="font-autoscape text-sm">3+0</h4>
        </div>
        {#if currentRating && $sessionData.selectedCard === 'blitz'}
          <div transition:fade class="title-rating flex flex-col">
            <h3 class="text-xl font-brown">rating</h3>
            <h3>{currentRating}</h3>
          </div>
        {/if}
        <div class="mx-auto translate-y-16 w-32 h-48">
          <Lottie path="timecontrol_blitz_highlight.json" speed={1.2}/>
        </div>
        {#if $sessionData.playerState !== PLAYER_STATE.lobbyGameRequestSent}
          <PlayButton {allowed} handleClick={sendLobbyGameRequest}
                      selected={$sessionData.selectedCard === 'blitz'}/>
                    {:else if $sessionData.selectedCard === 'blitz'}
                      <Looking/>
                    {/if}
                    <p class="{$sessionData.selectedCard === 'blitz' ? 'active-slide text-white mt-8 w-full' : 'inactive-slide text-gray-500 mt-8'}">
                      {$_('gameplay.gameTypes.blitz.description')}</p>
      </div>


      <div on:click="{() => switchSelectedCard('puzzle')}"
           class="{$sessionData.selectedCard === 'puzzle' ? 'p-8 card-selected flex flex-col' : 'card flex flex-col p-8'}">

        <div class="title gap-x-3 flex flex-row">
          <h3>puzzle</h3>
        </div>
        {#if $sessionData.selectedCard === 'puzzle'}
          <div transition:fade class="title-rating flex flex-col">
            <h3 class="text-xl font-brown">rating</h3>
            <h3>{$sessionData.puzzleRating}</h3>
          </div>
        {/if}
        <div class="mx-auto translate-y-16 w-32 h-48">
          <Lottie path="puzzle.json" speed={1.2}/>
        </div>
        {#if $sessionData.playerState !== PLAYER_STATE.lobbyGameRequestSent}
             <PlayButton {allowed} handleClick={startPuzzleMode}
                         selected={$sessionData.selectedCard === 'puzzle'}/>
                    {:else if $sessionData.selectedCard === 'puzzle'}
                      <Looking/>
                    {/if}
                    <p class="{$sessionData.selectedCard === 'puzzle' ? 'active-slide text-white mt-8 w-full' : 'inactive-slide text-gray-500 mt-8'}">
                      {$_('puzzle.puzzleDescription')}</p>
      </div>


    </div>

    <div class="staker">
      <div class="thestake">

        <div on:click={toggleStakeModal} class="flex flex-row gap-x-3">
          <h1 class="font-brown text-gray">{$_('common.stakeLabel')}</h1>
          <img src="information.svg" class="w-4 transition-all cursor-pointer hover:scale-150 " alt="information.svg">
        </div>
        <Stake bind:selection={currentStake}/>
        {#if $sessionData.selectedCard === 'puzzle'}
        {:else if $sessionData.guser.remaining_games && !all_levels}
          <div in:fade class="mt-10 font-autoscape text-sm">
            {$_('gameplay.stakes.unlockNext', {values: {amount: $sessionData.guser.remaining_games}})}
          </div>
        {:else if all_levels}
          <div in:fade class="mt-10 font-autoscape text-sm">
            {$_('gameplay.stakes.allUnlocked')}
          </div>
        {/if}
                              </div>

    </div>
</div>
        </div>
      {/if}
    </div>

   {#if $sessionData.playerState === PLAYER_STATE.puzzle}
     <Puzzle token={tok}/>
   {:else}
       <Game/>
   {/if}

  </div>
{/if}

<style>
  .container-card {
    position: relative;
    height: 300px;
    width: 550px;
    grid-area: cards;

    margin:auto;
    z-index: 500;
    /* top: 25vtake
    /* left: calc(-50vh + px); */
    display: flex;
  }

  .card {
    display: flex;
    height: 280px;
    width: 300px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    background-color: #212121;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: -1rem 0 3rem #000;
    /*   margin-left: -50px; */
    transition: 0.4s ease-out;
    position: relative;
    left: 0;
  }

  .card-selected ~ .card {
    position: relative;
    left: 130px;
    cursor: pointer;
    transition: 0.4s ease-out;

  }

  .card-selected:not(:first-child) {
    margin-left: -90px;
    cursor: pointer;
  }

  .card-selected {
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    height: 500px;
    width: 280px;
    cursor: pointer;
    overflow: hidden;
    /* background-color: #212121; */
    background-color: #5e5e5e;
    transform: translateY(-10rem);
    border-radius: 10px;
    box-shadow: -1rem 0 3rem #000;
    /*   margin-left: -50px; */
    transition: 0.4s ease-out;
    position: relative;
    left: -15px;
  }

  .card:not(:first-child) {
    margin-left: -90px;
    cursor: pointer;
  }

  .card:hover {
    transform: translateY(-20px);
    transition: 0.4s ease-out;
    cursor: pointer;
    transition-delay: 0.08s;
    background-color: #5e5e5e;
  }

  .card:hover ~ .card {
    position: relative;
    cursor: pointer;
    left: 95px;
    transition: 0.4s ease-out;
  }

  .title {
    color: white;
    font-weight: 300;
    font-size: 35px;
    position: absolute;
    left: 20px;
    top: 15px;
  }

  .title-rating {
    color: white;
    font-family: "Autoscape";
    font-weight: 300;
    font-size: 35px;
    position: absolute;
    right: 20px;
    top: 11px;
  }

  .inactive-slide {
    opacity: 0;
    transform: translateX(-10px);
    transition: 0.4s;
    /* transition: 1 */

  }

  .active-slide {
    opacity: 1;
    transform: translateX(0px);
    transition: 0.4s;
    transition-delay: 0.2s;

  }

  @keyframes wipe-in-down {
    0% {
      clip-path: inset(0 0 100% 0);
    }
    50% {
      clip-path: inset(0 0 0 0);
    }

    100% {
      clip-path: inset(0 0 100% 0);
    }
  }

  @keyframes facespinner {
    0% {
      transform: translate(-50%, 20%);
    }
    30% {
      transform: translate(0%, 30%);
    }
    60% {
      transform: translate(50%, 20%);
    }
    80% {
      transform: translate(0%, 30%);
    }
  }

  @keyframes facespinnereye {
    0% {
      transform: scaleY(1);
    }
    80% {
      transform: scaleY(1);
    }
    85% {
      transform: scaleY(0);
    }
    90% {
      transform: scaleY(1);
    }
    95% {
      transform: scaleY(0);
    }
  }

  .hide {
    display: none !important;
  }
  .play-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 0.7fr 1.2fr;
    /* height: 100vh; */
    grid-template-areas:
      ". . linko linko"
      ". cards cards ."
      ". stake stake ."
  }

  .link-place {
    grid-area: linko;
    align-self: end;
    justify-self: center;
    margin-bottom: 1rem;
  }

  .staker {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
    gap: 0px 0px;
    grid-template-areas:
      ". . ."
      ". thestake ."
      ". thestake ."
      ". . .";
    grid-area: stake;
  }
  .thestake {
    grid-area: thestake;
    margin: auto;

  }


  .continue-sumsub {

    height: 60vh;
    width: 30vw;
    position: absolute;
    top: 25%;
    left: 10%;


  }

  .hidescroll::-webkit-scrollbar {
    display: none;
  }




</style>
